exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".noticia-page[data-v-73952183]{padding:0 4rem 4rem}@media (max-width:1024px){.noticia-page[data-v-73952183]{padding:1rem}}.noticia-page .content main[data-v-73952183]{width:100%;display:flex;justify-content:center}@media (max-width:768px){.noticia-page .content main[data-v-73952183]{flex-direction:column}}", ""]);

// exports
